export default __webpack_public_path__ + "static/media/new-auth-background.5e11769c.png";